import type { SolrParams } from '#shared/solr'
import { JOURNAL_ARTICLE_NUMBER } from '#shared/utils/journal-article'

export interface JournalArticleRoute {
  variant: 'issue' | 'volume'
  publisherId: string
  articleNumber: string
  issueNumber: string
  volume: string
  issue: string
}

export function journalArticleQuery(route: JournalArticleRoute): SolrParams {
  // The server rejects other id forms with 400, and the whole issue still finds such an article by its last id segment
  const narrowing = JOURNAL_ARTICLE_NUMBER.test(route.articleNumber)
    ? { articleNumber: route.articleNumber }
    : {}

  if (route.variant === 'issue') {
    if (!route.publisherId || !route.issueNumber) {
      return {} as SolrParams
    }

    return {
      publisherId: route.publisherId,
      issue: route.issueNumber,
      ...narrowing,
    } as unknown as SolrParams
  }

  if (!route.publisherId || !route.volume || !route.issue) {
    return {} as SolrParams
  }

  return {
    publisherId: route.publisherId,
    volume: route.volume,
    issue: route.issue,
    ...narrowing,
  } as unknown as SolrParams
}
